import { render, staticRenderFns } from "./QualificationsAdd.vue?vue&type=template&id=3b778d16&scoped=true&"
import script from "./QualificationsAdd.vue?vue&type=script&lang=js&"
export * from "./QualificationsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b778d16",
  null
  
)

export default component.exports